import { pf9DocOrigin } from 'app/constants'

export const argoCDReleaseDocs = 'https://argo-cd.readthedocs.io/en/stable/'
export const argoCDQuickstart = `${pf9DocOrigin}/argo/argocd-quickstart`

export const argoCDTerms = `${pf9DocOrigin}/kubernetes/platform9-early-access-program`
